import { IP360PartnerFlags } from 'partner360/models/p360PartnerFlags/IP360PartnerFlags'

import { IPreparedTopPartner } from '../models'

import { getFlagRequestDirection } from './getFlagRequestDirection'
import { getMarketCoverage } from './getMarketCoverage'
import { isActiveFlagRequest } from './isActiveFlagRequest'

// Sums the coverage that partners with a pending (not-yet-approved) request to REMOVE this
// flag would lose once approved. These partners still have the flag in BitClass right now,
// so `sumMarketCoverage` already counts them in the base total — this is purely the
// forward-looking "what would be lost" indicator, mirroring sumPendingAddCoverage.
// Same isActiveFlagRequest gating as sumPendingAddCoverage — getFlagRequestDirection alone
// doesn't know whether the request is still pending.
export const sumPendingRemoveCoverage = (
  partners: IPreparedTopPartner[],
  flag: IP360PartnerFlags
) => {
  const values = partners
    .filter(
      (partner) =>
        isActiveFlagRequest(partner.RequestStatus) &&
        getFlagRequestDirection(partner, flag) === 'removed'
    )
    .map((partner) => getMarketCoverage(partner.Coverage, flag))
    .filter((value): value is number => value !== null)

  if (!values.length) {
    return null
  }

  return values.reduce<number>((sum, value) => sum + value, 0)
}
